export function buildRange(start, end, step) {
  const items = [];
  for (let i = start; i <= end; i += step) {
    items.push(i);
  }
  return items;
}

export function parseTime(value) {
  const [hourPart, minutePart] = String(value).split(':');
  return {
    hour: Number(hourPart) || 0,
    minute: Number(minutePart) || 0,
  };
}

export function formatTime(hour, minute) {
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}

export function normalizeTime(value) {
  const { hour, minute } = parseTime(value);
  return formatTime(hour, minute);
}

export function formatLegacyTime(hour, minute) {
  return `${hour}:${String(minute).padStart(2, '0')}`;
}

export function getCurrentTimeRounded(interval) {
  const now = new Date();
  let hours = now.getHours();
  let minutes = Math.round(now.getMinutes() / interval) * interval;

  if (minutes === 60) {
    minutes = 0;
    hours = (hours + 1) % 24;
  }

  return formatTime(hours, minutes);
}
